module.exports = __webpack_public_path__ + "d4e9c3be4c963ad1afbd50d525f51586.png";